// Base URL for the Blueroad API
export const BASE_URL = 'https://palevioletred-goldfish-323456.hostingersite.com/';

/**
 * Get a value from localStorage by key (Next.js safe)
 * @param {string} key - The key to retrieve
 * @returns {string|null} - The stored value, or null if not found
 */
export function getFromLocalStorage(key) {
  if (typeof window !== 'undefined') { // ensures code runs only in browser
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error(`Error getting "${key}" from localStorage:`, error);
    }
  }
  return null;
}
